import React from "react";
import { CountryOptionContentProps } from "../utils/types";
import FlagIconCDN from "../../FlagIconCDN/FlagIconCDN";

const CountryOptionContent: React.FC<CountryOptionContentProps> = ({
  country,
}) => (
  <div className="flex items-center gap-[10px]">
    <FlagIconCDN
      code={country.flag}
      flagIconClassName="w-[18px] h-[14px] shrink-0"
    />
    <div className="text-md font-normal text-heading-text dark:text-heading-text-dk truncate">
      {country.name} ({country.dialCode})
    </div>
  </div>
);

export default CountryOptionContent;
